import { GetDepositPromotionNamesForSelectorResponse } from '@/modules/promotion/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { DepositPromotionQueryKeys } from '@/modules/promotion/keys'
import { getDepositPromotionNamesForSelector } from '../../services'

export default function useQueryGetDepositPromotionNamesForSelector(
	props?: UseBaseQueryOptions<GetDepositPromotionNamesForSelectorResponse>,
) {
	return useQuery({
		queryKey: [DepositPromotionQueryKeys.GetDepositPromotionNamesForSelector],
		queryFn: () => getDepositPromotionNamesForSelector(),
		...props,
	})
}
